import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../store/UserStore/context";
import { isTestUser, forgetTestUser } from "../../testUser";
import styles from "./index.module.css";

export default function TestUserBanner() {
  const context = useContext(UserContext);
  const navigate = useNavigate();

  if (!isTestUser(context.store.user)) return null;

  return (
    <div className={styles.banner} role="status">
      <span>Тестовий акаунт — оплата все одно реальна</span>
      <button
        type="button"
        className={styles.exit}
        onClick={() => {
          forgetTestUser();
          context.actions.setUser(null);
          navigate("/");
        }}
      >
        Вийти
      </button>
    </div>
  );
}
